import { Box, Typography, Stack } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { FcBusinessman, FcBusinesswoman } from 'react-icons/fc';
import { useTeacherStudents } from '@/hooks/useTeacherStudents';
import { Loader } from '@/components/feedback/Loader';
import { StatusBadge } from '@/components/feedback/StatusBadge';

export function MyStudentsPage() {
  const { students, loading } = useTeacherStudents();

  const columns = [
    { 
      field: 'name', 
      headerName: 'Student', 
      flex: 1,
      minWidth: 250,
      valueGetter: (params, row) => `${row.firstName} ${row.lastName}`,
      renderCell: (params) => {
        const isFemale = params.row.gender === 'Female';
        return (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, height: '100%' }}>
            {isFemale ? <FcBusinesswoman size={24} /> : <FcBusinessman size={24} />}
            <Typography variant="body2" fontWeight={600}>{params.value}</Typography>
          </Box>
        );
      }
    },
    { field: 'rollNumber', headerName: 'Roll No', width: 100 },
    { field: 'admissionNumber', headerName: 'Admission No', width: 130 },
    { field: 'className', headerName: 'Class', width: 100 },
    { field: 'sectionName', headerName: 'Section', width: 100 },
    { field: 'gender', headerName: 'Gender', width: 100 },
    { 
      field: 'status', 
      headerName: 'Status', 
      width: 120,
      renderCell: (params) => <StatusBadge status={params.value} />
    }
  ];

  return (
    <Box>
      <Box mb={4}>
        <Typography variant="h4" fontWeight={700} gutterBottom>
          My Students
        </Typography>
        <Typography color="text.secondary">
          Students enrolled in the classes you teach
        </Typography>
      </Box>

      <Box sx={{ height: 600, width: '100%', bgcolor: 'background.paper', borderRadius: 2, overflow: 'hidden' }}>
        <DataGrid
          rows={students}
          columns={columns}
          loading={loading}
          pageSizeOptions={[10, 25, 50]}
          initialState={{
            pagination: { paginationModel: { pageSize: 10 } },
          }}
          disableRowSelectionOnClick
          sx={{ border: 0 }}
        />
      </Box>
    </Box>
  );
}
